import type { BootItem, MorningBootContextAdapter } from '@priorities-ai/morning-boot';

export const ELEVATION_BOOT_STORAGE_KEY = 'priorities_morning_boot';

export function createElevationAdapter(): MorningBootContextAdapter {
  return {
    northStarLabel: 'North Star',
    northStarText: undefined,
    suggestItems(): BootItem[] {
      return [];
    },
    suggestRoles(): string[] {
      return [
        'Partner / spouse',
        'Manager',
        'Team',
        'Customer',
        'Mentor',
        'Board / leadership',
      ];
    },
  };
}
